
import { v4 } from "uuid";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			uid: v4(),
		};
	},
	props: {
		value: Number
	},
	computed: {
		quarters():number[]{
			return [1, 2, 3, 4];
		}
	},
	methods: {
		setQuarter(i:number){
			this.$emit("input", i);
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
